import "../plugins/templates";

(function () {

    function calculate(type, formObject) {

        var matrix = [];
        if (type === 1) {
            matrix = [
                [[30, 0, 0], [20, 0, 0]],
                [[50, 0, 0], [40, 0, 0]],
                [[70, 0, 0], [60, 0, 0]],
                [[115, 1, 0], [100, 1, 0]],
                [[180, 1, 1, '(Wenn innerhalb eines Jahres ab Rechtskraft der ersten Entscheidung ein zweites Mal eine Geschwindigkeitsüberschreitung um mehr als 25 km/h festgestellt wird.)'], [150, 1, 1, '(Wenn innerhalb eines Jahres ab Rechtskraft der ersten Entscheidung ein zweites Mal eine Geschwindigkeitsüberschreitung um mehr als 25 km/h festgestellt wird.)']],
                [[260, 2, 1], [200, 1, 1, '(Wenn innerhalb eines Jahres ab Rechtskraft der ersten Entscheidung ein zweites Mal eine Geschwindigkeitsüberschreitung um mehr als 25 km/h festgestellt wird.)']],
                [[400, 2, 1], [320, 2, 1]],
                [[560, 2, 2], [480, 2, 1]],
                [[700, 2, 3], [600, 2, 2]],
                [[800, 2, 3], [700, 2, 3]]
            ];
            return getResult(matrix[formObject.wieviel][formObject.wo]);
        }
        if (type === 2) {
            matrix['000'] = [90, 1, 0];
            matrix['010'] = [200, 2, 1];
            matrix['011'] = [240, 2, 1];
            matrix['100'] = [200, 2, 1];
            matrix['110'] = [320, 2, 1];
            matrix['111'] = [360, 2, 1];
            return getResult(matrix[formObject.rotphase + formObject.gefaehrdung + formObject.sachschaden]);
        }
        if (type === 3) {
            matrix = [
                [[75, 1, 0], [75, 1, 0], [100, 1, 0]],
                [[100, 1, 0], [100, 1, 0], [180, 1, 0]],
                [[160, 1, 0], [160, 2, 1], [240, 2, 1]],
                [[240, 1, 0], [240, 2, 2], [320, 2, 2]],
                [[320, 1, 0], [320, 2, 3], [400, 2, 3]]
            ];
            return getResult(matrix[formObject.abstand][formObject.geschw]);
        }

    }

    function getResult(result) {
        return {
            'euros': result[0],
            'points': result[1],
            'months': result[2] +  ' Monat' + (result[2] === 0 || result[2] > 1 ? 'e' :'') ,
            'comment': typeof result[3] !== 'undefined' ? result[3] : ''
        };
    }

    function objectifyForm(formArray) {
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return returnArray;
    }

    var $form = $('form#fineCalculator');
    var $fineCalculatorSelect = $('#fineCalculatorSelect');
    var $result = $('#fineCalculatorResult');
    var $calculators = $('.fineCalculatorFields');

    $fineCalculatorSelect.on('change', function () {
        $calculators.filter(':visible').fadeOut('slow', function () {
            $calculators.filter('[data-finecalculator=' + $fineCalculatorSelect.val() + ']').fadeIn();
        });
        $result.hide();
    });

    $form.find('[name=sachschaden]').on('change', function () {
       if($form.find('[name=sachschaden]:checked').val() === "1" && $('#gefaehrdung1').is(':checked')) {
           $('#gefaehrdung0').prop('checked', true);
       }
    });

    $form.find('[name=gefaehrdung]').on('change', function () {
       if($form.find('[name=gefaehrdung]:checked').val() === "0") {
           $('#sachschaden1').prop('checked', true);
       }
    });

    $form.on('submit', function (e) {
        e.preventDefault();
        var formObject = objectifyForm($(this).serializeArray());
        var result = calculate(Number($fineCalculatorSelect.val()), formObject);
        $result.html(hbs.templates.fineCalculator(result));
        $result.hide().fadeIn('fast');
    });

})();
